import { useNavigate } from "react-router";

import { BrandLogo } from "@/components/brand-logo";
import { Button } from "@/components/ui/button";
import { useLogout } from "@/lib/api";

// Constant-length JSX expression keeps prettier output stable for any rendered name.
const PROJECT_NAME = "MDP UAT Review";

export function HomePage() {
  const navigate = useNavigate();
  const logoutMutation = useLogout();

  const handleLogout = async () => {
    await logoutMutation.mutateAsync();
    navigate("/login");
  };

  return (
    <div className="bg-background flex h-screen flex-col">
      <header className="border-border/80 bg-card/95 flex shrink-0 items-center justify-between border-b px-6 py-3 backdrop-blur">
        <BrandLogo name={PROJECT_NAME} className="h-7 text-lg" />
        <div className="flex items-center gap-3">
          <Button variant="outline" size="sm" onClick={handleLogout}>
            Sign out
          </Button>
        </div>
      </header>
      {/* The wave planner is a standalone page served by the backend behind the
          session cookie; it persists through /api/planner/db. */}
      <iframe src="/api/planner" title="MDP Wave Planner" className="w-full flex-1 border-0" />
    </div>
  );
}
